import { useState } from "react";
import FAQItem from "./FAQItem";

function FAQLight({ faqList }) {
  const [openIndex, setOpenIndex] = useState(null);

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="border-b border-gray-200">
      <div className="overflow-hidden">
        {faqList.map((item, index) => (
          <FAQItem
            key={index}
            question={item.question}
            answer={item.answer}
            open={openIndex === index}
            onToggle={() => handleToggle(index)}
          />
        ))}
      </div>
    </div>
  );
}

export default FAQLight;
